import React, { useEffect } from "react";

import { useResourcesState } from "@/state/resourcesState";
import { BrowserRouter, Route, Routes } from "react-router";
import { FurnitureDemo } from "./route/FurnitureDemo";
import { Editor } from "./route/Editor";
import { useDebugState } from "@/state/debugState";

export const App = () => {
    const { load } = useResourcesState();
    const { setIsDebugEnabled } = useDebugState();

    useEffect(() => {
        load();

        const debugLocalStorageKey = "debug";
        const debugLocalStorageValue = localStorage.getItem(debugLocalStorageKey);
        if (debugLocalStorageValue) {
            setIsDebugEnabled(debugLocalStorageValue === "true");
        }
    }, []);

    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<FurnitureDemo />} />
                <Route path="/editor" element={<Editor />} />
            </Routes>
        </BrowserRouter>
    );
};
